import React from 'react'
import './footer.css'

const Footer = ({isDarkMode}) => {
  const bodyClass = `footer ${isDarkMode ? "dark-mode" : ""}`;
    
  return (
    <footer className={bodyClass}>
      <div className="footer__container container">
        <h1 className="footer__title">Rizvi</h1>

        <ul className="footer__list">

        <li>
            <a href="#home" className="footer__link">Home</a>
          </li>

          <li>
            <a href="#about" className="footer__link">About</a>
          </li>

          <li>
            <a href="#portfolio" className="footer__link">Projects</a>
          </li>

        </ul>

        <div className="footer__social">
          <a href="https://www.linkedin.com/in/kumail-rizvi-2772071a0/" className="home__social-icon" target='_blank'>
            <i className="uil uil-linkedin-alt"></i>
          </a>
          <a href="https://twitter.com/sayedkumail_" className="home__social-icon" target='_blank'>
            <i className="uil uil-twitter-alt"></i>
          </a>
          <a href="https://github.com/Skumail-code" className="home__social-icon" target='_blank'>
            <i className="uil uil-github-alt"></i>
          </a>
        </div>

        <div className="footer__copy">&#169; Kumail Rizvi. All rights reserved</div>
      </div>
    </footer>
  )
}

export default Footer
